// extracted by mini-css-extract-plugin
export default {"root":"ConfigureHideOnSessionViewCheckbox_root__15NhR"};